"use client";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Image from "next/image";
import React from "react";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function ModalComponent({
  open,
  handleModal,
  transitionReqd,
  title,
  extraFunction,
  children,
  contentSx = {},
  fullScreen = false,
  closeButtonRequired = true,
  direction = "column",
  titleColor = "black",
  maxWidth = "sm",
  subtitle = "",
  titleSx = {},
  subtitleSx = {},
  titleBg = "transparent",
  ...props
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleClose = () => {
    if (extraFunction) {
      extraFunction();
    }
    handleModal(false);
  };

  return (
    <Dialog
      PaperProps={{ sx: { borderRadius: { md: "16px", xs: "8px" } } }}
      fullWidth
      open={open}
      maxWidth={maxWidth}
      fullScreen={fullScreen}
      TransitionComponent={Transition}
      aria-describedby="alert-dialog-slide-description"
      {...props}
    >
      <Stack>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          position={"relative"}
        >
          <Stack spacing={1}>
            {title && (
              <DialogTitle
                sx={{ color: titleColor, backgroundColor: titleBg, ...titleSx }}
              >
                {title}
              </DialogTitle>
            )}
            {subtitle && (
              <DialogTitle
                sx={{
                  color: titleColor,
                  py: 0,
                  fontSize: "16px",
                  mt: -3,
                  color: WEB_COLORS.textFadeColor,
                  fontWeight: 400,
                  ...subtitleSx,
                }}
              >
                {subtitle}
              </DialogTitle>
            )}
          </Stack>
          {closeButtonRequired && (
            <Image
              src={IMAGES.close}
              alt="Close"
              onClick={handleClose}
              style={{
                cursor: "pointer",
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 1000,
              }}
              height={25}
              width={25}
            />
          )}
        </Stack>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: `${direction === "column" ? "column" : "row"}`,
            ...contentSx,
          }}
        >
          {children}
        </DialogContent>
      </Stack>
    </Dialog>
  );
}
